var _excluded = ["align", "caps", "children", "className", "color", "dataSpacer", "id", "italic", "resetSpacing", "tag", "type", "uppercase", "weight"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import { getCustomAttributes, getCustomClassNames } from "./text.utils";
export var TEXT_TYPES = {
  NORMAL: "normal",
  SMALL: "small",
  LABEL: "label",
  CAPTION: "caption",
  HEADING: "heading",
  HEADING_EXTRA: "heading-extra",
  HEADING_BIG: "heading-big",
  HEADING_SMALL: "heading-small",
  SUBHEAD: "subhead",
  SUBHEAD_SMALL: "subhead-small",
  MINOR: "minor",
  EDITO: "edito"
};
export var TEXT_COLORS = {
  BLACK: "black",
  WHITE: "white",
  GREY: "grey",
  GREY_LIGHT: "greyLight",
  MAIN_COLOR: "mainColor",
  SECOND_COLOR: "secondColor",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error"
};
export var TEXT_ALIGNS = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right"
};
export var TEXT_WEIGHTS = {
  LIGHT: "light",
  NORMAL: "normal",
  MEDIUM: "medium",
  SEMI_BOLD: "semi-bold",
  BOLD: "bold",
  EXTRA_BOLD: "extra-bold",
  BLACK: "black"
};

/**
 * The types of the props that are used in the Text component
 */

/**
 * The type of all the props of the Text component
 */

/**
 * The 2 types of the Text component
 */

// eslint-disable-next-line react/function-component-definition
export function Text(_ref) {
  var align = _ref.align,
    _ref$caps = _ref.caps,
    caps = _ref$caps === void 0 ? false : _ref$caps,
    children = _ref.children,
    className = _ref.className,
    color = _ref.color,
    dataSpacer = _ref.dataSpacer,
    id = _ref.id,
    _ref$italic = _ref.italic,
    italic = _ref$italic === void 0 ? false : _ref$italic,
    _ref$resetSpacing = _ref.resetSpacing,
    resetSpacing = _ref$resetSpacing === void 0 ? false : _ref$resetSpacing,
    tag = _ref.tag,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TEXT_TYPES.NORMAL : _ref$type,
    _ref$uppercase = _ref.uppercase,
    uppercase = _ref$uppercase === void 0 ? false : _ref$uppercase,
    weight = _ref.weight,
    restProps = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var CustomTag = tag || "p";
  return /*#__PURE__*/React.createElement(CustomTag, _extends({}, getCustomAttributes({
    id: id,
    dataSpacer: dataSpacer
  }), {
    className: getCustomClassNames({
      type: type,
      color: color,
      align: align,
      caps: caps,
      italic: italic,
      uppercase: uppercase,
      className: className,
      weight: weight,
      resetSpacing: resetSpacing
    })
  }, restProps), children);
}